import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import BaseWrapper from 'components/atoms/base-wrapper';
import { SearchFolderIcon } from 'components/atoms/icons/search-folder';
import BaseForm from 'components/atoms/base-form';
import BaseFormItem from 'components/atoms/base-form/item';
import BaseButton from 'components/atoms/baseButton';
import { DateFormatter } from 'infrastructure/functions';
import { DateFormats } from 'infrastructure/enums';
import PatientSelectBox from 'components/molecules/patient-select-box';

import s from './styles.module.scss';

export interface IFormValues {
  patientGuid?: string;
}

interface IProps {
  onSubmit: (patientGuid: string) => void;
}

const UnknownNumberForm: React.FC<IProps> = (props) => {
  const { onSubmit } = props;
  const { t } = useTranslation();

  const formik = useFormik<IFormValues>({
    initialValues: {
      patientGuid: undefined,
    },
    onSubmit: ({ patientGuid }) => {
      if (patientGuid) onSubmit(patientGuid);
    },
  });

  return (
    <BaseWrapper className={s.wrapper}>
      <div className={s.top}>
        <SearchFolderIcon />
        <span className={s.message}>
          {t('messages.unknownNumberPatientSelect')}
        </span>
      </div>
      <div className={s.bottom}>
        <BaseForm formik={formik} className={s.form}>
          <BaseFormItem name="patientGuid" label={t('labels.patient')}>
            <PatientSelectBox
              placeholder={t('labels.searchPatient')}
              allowClear
              labelRender={(el) => {
                const date = DateFormatter({
                  date: el.record?.birthDate,
                  format: DateFormats['MM-dd-yyyy'],
                  toUTC: true,
                });
                return `${el.label} ${date}`;
              }}
            />
          </BaseFormItem>
          <BaseButton
            disabled={!formik.values.patientGuid}
            className={s.submit}
            width="100%"
            label={t('controls.submit')}
            onClick={formik.submitForm}
          />
        </BaseForm>
      </div>
    </BaseWrapper>
  );
};

export default UnknownNumberForm;
